import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { TypeAccesPersonneMoraleDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-acces',
  templateUrl: './types-acces.component.html',
  styleUrls: ['./types-acces.component.css']
})
export class TypesAccesComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.typesAcces$) typesAcces$: Observable<TypeAccesPersonneMoraleDto[]>;

  @Input() typeAccesId: number;
  public TypeAccesInComponent: TypeAccesPersonneMoraleDto;

  private p: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.p = this.typesAcces$.subscribe(res => {
      if (res != null) {
        let typesAcces = res.filter(p => p.Id == this.typeAccesId);
        this.TypeAccesInComponent = typesAcces.length == 1 ? typesAcces[0] : { Identifiant: null };
      }
    });
  }
  ngOnDestroy() {
    this.p?.unsubscribe();
  }

}
